import axios      from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES }  from '@shared/constants/apiConfig';
import { getError }  from '@shared/utils/helpers';

const path = `${SERVICES.ACCOUNTING}`;

export const requestImportFile = async(files: File[]) => {
  const url = `${path}/productcancellations/importfile`;
  const formData = new FormData();
  files.map((file: File) => {
    formData.append('files', file as string | Blob | File);
  });

  try {
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    await axios.post(url, formData, config);
    Notistack.successMessage('Files imported successfully');
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestDeleteProductCancellation = (id: string) => {
  const url = `${path}/productcancellations/checks/${id}`;

  return mutate(path, async() => {
    try {
      await axios.delete(url);
      Notistack.successMessage('Product Cancellation Check - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
